import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPurpleWarningIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 45,
	viewBox: "0 0 43 45",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25.891,
			cy: 28.5,
			rx: 3.76599,
			ry: 3.5,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 23,
			cy: 25,
			r: 16,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 39.5318,
			cy: 37.5,
			rx: 2.53176,
			ry: 2.5,
			fill: "#BCA4FF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.0127,
			cy: 44,
			rx: 1.0127,
			ry: 1,
			fill: "#6A4BC0"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.0127,
			cy: 1,
			rx: 1.0127,
			ry: 1,
			fill: "#BCA4FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 23.5,
			cy: 7.5,
			r: 2.5,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9948 41.6693C29.1615 41.6693 36.6615 34.1693 36.6615 25.0026C36.6615 15.8359 29.1615 8.33594 19.9948 8.33594C10.8281 8.33594 3.32812 15.8359 3.32812 25.0026C3.32812 34.1693 10.8281 41.6693 19.9948 41.6693Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 18.3359V26.6693",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9922 31.6641H20.0072",
			stroke: "#7548F0",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPurpleWarningIcon;
